import {
  addDoc,
  deleteDoc,
  deleteField,
  getDoc,
  getDocs,
  collection,
  doc,
  updateDoc,
  query,
  where,
  serverTimestamp,
} from "firebase/firestore";

// Local imports
import { db } from "./firebaseConfig";

const createList = async (data) => {
  const listRef = await addDoc(collection(db, "lists"), data);
  return listRef.id;
};

const getAllDocs = async (uid) => {
  const data = [];
  const q = query(collection(db, "lists"), where("uid", "==", uid));
  const querySnapshot = await getDocs(q);
  querySnapshot.forEach((doc) => {
    data.push({ ...doc.data(), id: doc.id });
  });
  return data;
};

const getSingleDoc = async (docRef) => {
  return await getDoc(docRef);
};

const deleteList = async (listId) => {
  await deleteDoc(doc(db, "lists", listId));
};

const createTodo = async (listId, title) => {
  const listRef = doc(db, "lists", listId);
  await updateDoc(listRef, {
    [`todos.${title}`]: {
      completed: false,
      createdAt: serverTimestamp(),
    },
  });
};

const toggleTodo = async (listId, todoText, markState) => {
  const listRef = doc(db, "lists", listId);
  await updateDoc(listRef, {
    [`todos.${todoText}.completed`]: markState,
  });
};

const getListById = async (id) => {
  const ref = doc(db, "lists", id);
  const listSnap = await getDoc(ref);

  if (listSnap.exists()) {
    return listSnap.data();
  }
  return null;
};

const deleteTodo = async (listId, todoText) => {
  const listRef = doc(db, "lists", listId);
  await updateDoc(listRef, { [`todos.${todoText}`]: deleteField() });
};

export {
  createList,
  getListById,
  getSingleDoc,
  getAllDocs,
  deleteList,
  createTodo,
  deleteTodo,
  toggleTodo,
};
